import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { ConstantsService } from './constants.service';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class SavedSearchService extends BaseService {

  constructor(public override http: HttpClient, public override constants: ConstantsService) {
    super(http, constants, constants.api_saved_search);
  }

  saveSearch(fileName: string, formData: any) {
    let query = this.encode(formData);
    const blob = new Blob([query], {type:'text/plain'});
    saveAs(blob, fileName);
  }

  loadSearch(query: string) {
    return this.decode(query);
  }

}
